import React from "react";
import Nav from "../../components/nav";
import Hero1 from "../../components/hero-1";
import HostInfo from "../../components/hostInfo";
import InfinityIcon from "../../assets/icons/InfinityIcon";
import BellFillIcon from "../../assets/icons/BellFillIcon";
import SubtitlesIcon from "../../assets/icons/SubtitlesIcon";
import FileEarmarkEaselFillIcon from "../../assets/icons/FileEarmarkEaselFillIcon";
import PencilIcon from "../../assets/icons/PencilIcon";
import {ReactComponent as Arrow1} from './../../assets/svg/arrow1.svg';
import PerformanceIcon from "../../assets/icons/PerformanceIcon";
import ServersIcon from "../../assets/icons/ServersIcon";
import TimelineClockOutlineIcon from "../../assets/icons/TimelineClockOutlineIcon";
import WaysUse from "../../components/ways-use";
import Footer from "../../components/footer";
import Gifsite1 from "../../assets/video/GifSite1.mp4";
import Gifsite1En from "../../assets/video/gifsite1-en.m4v";
import Gifsite2 from "../../assets/video/Gifsite2-1.m4v";
import WorldChart from "../../components/WorldChart";
import {useTranslation} from "react-i18next";
import {Helmet} from "react-helmet";


const Landing = ()=>{
    const { t } = useTranslation('common')
    return(
        <div id='landing-page'>
            <Helmet>
                <title>سامانه وب کنفرانس بل میت</title>
                <meta name="description" content="بل میت یک سامانه بومی و دانش بنیان برگزاری رویداد آنلاین و وب کنفرانس و کلاس آنلاین است." />
            </Helmet>
            <Nav/>
            <Hero1/>
            <HostInfo
              title={t('HostInfo1')}
              text={t('HostInfoText1')}
                video={t('lang') === 'fa' ? Gifsite1 : Gifsite1En}
              items={[
                {
                  text: t('HostInfoList1'),
                  icon:InfinityIcon
                },
                {
                  text:t('HostInfoList2'),
                  icon:BellFillIcon,
                  className:'yellow-item'
                },
                {
                  text:t('HostInfoList3'),
                  icon:SubtitlesIcon,
                  className:'blue-item'
                },
                {
                  text:t('HostInfoList4'),
                  icon:FileEarmarkEaselFillIcon,
                  className:'red-item'
                },
                {
                  text:t('HostInfoList5'),
                  icon:PencilIcon,
                  className:'purple-item'
                },
              ]}
            />
            <div className='arrow-div'>
              <Arrow1/>
            </div>
            <HostInfo
              title={t('HostInfo2')}
              text={t('HostInfoText2')}
              reverse
              video={Gifsite2}
              items={[
                {
                  text:t('HostInfoList6'),
                  icon:InfinityIcon
                },
                {
                  text:t('HostInfoList7'),
                  icon:TimelineClockOutlineIcon,
                  className:'yellow-item'
                },
                {
                  text:t('HostInfoList8'),
                  icon:ServersIcon,
                  className:'blue-item'
                },
                {
                  text:t('HostInfoList9'),
                  icon:PerformanceIcon,
                  className:'red-item'
                },
              ]}
            />
            <WaysUse/>
            <WorldChart/>
            <Footer/>
        </div>
    )
}

export default Landing